import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhotoCameraRoundedIcon from "@material-ui/icons/PhotoCameraRounded";
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    textAlign: 'center',
  },
  container: {
    maxWidth: "100%",
    maxHeight: "100%",
    marginTop: theme.spacing(2)   
  },
  imgBox: {
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "10px"
  },
  img: {
    height: "inherit",
    maxWidth: "inherit",
  },
  input: {
    display: "none"
  }
}));


function Cam({ fotoUrl, setFoto }) {
  const classes = useStyles();
  
  const handleCapture = (target) => {
    if (target.files) {
      if (target.files.length !== 0) {
        const file = target.files[0];       
        setFoto(file)
      }
    }
  };

  
  return (
    <div className={classes.root}>
      <Grid  className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="body1" color="textSecondary" align="center">
            Tome una foto de los enseres depositados.
          </Typography>      
          {fotoUrl &&
            <Box display="flex" justifyContent="center" className={classes.imgBox}>
              <img src={fotoUrl} alt={"snap"} className={classes.img}></img>
            </Box>}
          <input
            accept="image/*"
            className={classes.input}
            id="icon-button-file"
            type="file"
            capture="environment"
            onChange={(e) => handleCapture(e.target)}
          />
          <label htmlFor="icon-button-file">
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span">
              <PhotoCameraRoundedIcon color="primary" fontSize="large" />
            </IconButton>
          </label>
        </Grid>
      </Grid>
    </div>
  );
}


export default Cam;